import axios from "axios";

const api = axios.create({
  //   baseURL: "http://localhost:3333",
  baseURL: "https://api-belaflor.pmdtechsolutions.com.br",
  headers: {},
});

export default api;
